import { baseApi } from './baseApi';
import { withDefinedFields } from './apiUtils';

export const peopleApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrgUsers: builder.query({
      query: ({ organizationId, role }) => ({
        url: `/admin/organizations/${organizationId}/users`,
        params: role ? { role } : undefined,
      }),
      providesTags: (result, error, { organizationId }) => [
        { type: 'User', id: `ORG-${organizationId}` },
      ],
    }),
    createOrgUser: builder.mutation({
      query: ({ organizationId, ...body }) => ({
        url: `/admin/organizations/${organizationId}/users`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, { organizationId }) => [
        { type: 'User', id: `ORG-${organizationId}` },
      ],
    }),
    getUser: builder.query({
      query: (id) => `/admin/users/${id}`,
      providesTags: (result, error, id) => [{ type: 'User', id }],
    }),
    updateUser: builder.mutation({
      query: ({ id, name, email, role }) => {
        const body = {};
        if (name !== undefined) body.name = name;
        if (email !== undefined) body.email = email;
        if (role !== undefined) body.role = role;
        return { url: `/admin/users/${id}`, method: 'PATCH', body };
      },
      invalidatesTags: (result, error, { id, organizationId }) => [
        { type: 'User', id },
        { type: 'User', id: `ORG-${organizationId}` },
      ],
    }),
    resetUserPassword: builder.mutation({
      query: ({ id, password }) => ({
        url: `/admin/users/${id}/reset-password`,
        method: 'POST',
        body: { password },
      }),
    }),
    setUserActive: builder.mutation({
      query: ({ id, isActive }) => ({
        url: `/admin/users/${id}/active`,
        method: 'PATCH',
        body: { is_active: isActive },
      }),
      invalidatesTags: (result, error, { organizationId }) => [
        { type: 'User', id: `ORG-${organizationId}` },
      ],
    }),
    deleteUser: builder.mutation({
      query: ({ id }) => ({ url: `/admin/users/${id}`, method: 'DELETE' }),
      invalidatesTags: (result, error, { organizationId }) => [
        { type: 'User', id: `ORG-${organizationId}` },
      ],
    }),

    getHosts: builder.query({
      query: () => '/manager/hosts',
      providesTags: [{ type: 'User', id: 'HOSTS' }],
    }),
    createHost: builder.mutation({
      query: (body) => ({ url: '/manager/hosts', method: 'POST', body }),
      invalidatesTags: [{ type: 'User', id: 'HOSTS' }],
    }),
    updateHost: builder.mutation({
      query: ({ id, name, email }) => {
        const body = withDefinedFields([
          ['name', name],
          ['email', email],
        ]);
        return { url: `/manager/hosts/${id}`, method: 'PATCH', body };
      },
      invalidatesTags: [{ type: 'User', id: 'HOSTS' }],
    }),
    setHostActive: builder.mutation({
      query: ({ id, isActive }) => ({
        url: `/manager/hosts/${id}/active`,
        method: 'PATCH',
        body: { is_active: isActive },
      }),
      invalidatesTags: [{ type: 'User', id: 'HOSTS' }],
    }),
    removeHost: builder.mutation({
      query: (id) => ({ url: `/manager/hosts/${id}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'User', id: 'HOSTS' }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetOrgUsersQuery,
  useCreateOrgUserMutation,
  useGetUserQuery,
  useUpdateUserMutation,
  useResetUserPasswordMutation,
  useSetUserActiveMutation,
  useDeleteUserMutation,
  useGetHostsQuery,
  useCreateHostMutation,
  useUpdateHostMutation,
  useSetHostActiveMutation,
  useRemoveHostMutation,
} = peopleApi;
